// extracted by mini-css-extract-plugin
export var blockedMessage = "_b1-3";
export var blockedOverlay = "_b1-1";
export var fadeIn = "_b1-2";
export var hereLink = "_b1-0";
export var slideUp = "_b1-4";